<div fxFill fxLayout="column" class="login-wrapper">
    <ng-container *transloco="let t">
        <div fxFlex fxLayout="row" fxLayoutAlign="start stretch">
            <div fxFlex fxHide.xs fxHide.sm class="login-bg"></div>
            <div fxFlex="100" fxFlex.gt-sm="40" fxLayout="column" fxLayoutAlign.gt-sm="center center"
                fxLayoutAlign="start center" class="login-section">
                <div class="login-container theme-white">
                    <div class="logo">
                        <img style="height: 80px;" src="../../../../../assets/images/login-logo.png" alt="login-logo" />
                    </div>
                    <h2 class="set-password-title">
                        {{ t(forgotpass ? 'setPassword.ResettingPassword' : 'setPassword.SetPassword') }}
                    </h2>
                    <app-user-details *ngIf="!displayOtp" [id]="identifier" [isOnlinePay]="onlinepPay" [name]="name"
                        [showError]="showError" [showSpinner]="showSpinner" [forgotpass]="forgotpass"
                        (submit)="detailsVerify($event)">
                    </app-user-details>

                    <app-user-otp *ngIf="displayOtp" [id]="identifier" [isOnlinePay]="onlinepPay"
                        [otpWaitingInMinutes]="otpWaitingInMinutes ?? 0" [mobileNo]="mobileNo" [showError]="showError"
                        [showSpinner]="showSpinner" [unsuccessfullAttempt]="unsuccessfullAttempt"
                        [forgotpass]="forgotpass" [maxOtpResendAttempts]="maxOtpResendAttempts"
                        (submit)="otpVerify($event)">
                    </app-user-otp>
                </div>

                <div fxLayout="row" fxLayoutAlign.xs="center center" fxLayoutAlign.sm="center center"
                    fxLayoutAlign.gt-sm="start center" class="login-copyright-div">
                    <span class="login-copyright">{{ t('login.copyRight') }}</span>
                </div>
            </div>
        </div>

        <div class="login-lang-selection" *ngIf="languages?.length">
            <button mat-icon-button [matMenuTriggerFor]="languagemenu" class="lang-button" aria-label="Select Language">
                <mat-icon>language</mat-icon>
            </button>

            <mat-menu #languagemenu="matMenu" xPosition="before" class="lang-menu-panel">
                <button mat-menu-item *ngFor="let lang of languages" (click)="layoutService.selectLanguage(lang)">
                    {{ lang.name }}
                </button>
            </mat-menu>
        </div>



    </ng-container>
</div>